import { createElement, memo, useState, useEffect, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
import Image from '@hfe/max-image';
import Icon from '@max/leez-icon';
const MyComponent = (props) => {
    const { citydata, onChecked, checkedCity, isTop, singleCityStyle, zIndex } = props;
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const dom = document.querySelector('body');
        dom === null || dom === void 0 ? void 0 : dom.addEventListener('click', () => {
            setVisible(false);
        }, false);
        return dom === null || dom === void 0 ? void 0 : dom.removeEventListener('clcik', () => { }, false);
    }, []);
    const onClick = (item, index) => {
        onChecked(item, index);
        setVisible(false);
    };
    const style = useMemo(() => {
        if (isTop) {
            return {
                display: 'none'
            };
        }
        return {};
    }, [isTop]);
    const textStyle = useMemo(() => {
        return {
            bgColorHeight: singleCityStyle.fontSize == 'small' ? '48rpx' : '60rpx',
            fontSize: singleCityStyle.fontSize == 'small' ? '24rpx' : '28rpx',
            padding: singleCityStyle.fontSize == 'small' ? '12rpx 11rpx' : '18rpx 13rpx',
            textColor: singleCityStyle.textColor,
            bgColor: singleCityStyle.isBgColor ? singleCityStyle.bgColor : 'none',
            right: singleCityStyle.align === 'right' ? '24rpx' : 0
        };
    }, [singleCityStyle]);
    const textPosition = useMemo(() => {
        return singleCityStyle.align === 'right' ? {
            right: '24rpx'
        } : {};
    }, [singleCityStyle.align]);
    return <View className='city-deop-down-content'>
            <View className='city-deop-down-card' style={Object.assign({ position: 'absolute', height: textStyle.bgColorHeight, backgroundColor: textStyle.bgColor, padding: singleCityStyle.isBgColor ? textStyle.padding : 0 }, textPosition)} onClick={() => {
        setVisible(true);
    }}>
                <Text className='city-deop-down-text' style={{
        fontSize: textStyle.fontSize,
        color: textStyle.textColor
    }}>
                    {checkedCity === null || checkedCity === void 0 ? void 0 : checkedCity.title}
                </Text>
                <View style={{
        width: '9rpx'
    }}/>
                <Icon name={visible ? 'jiantouxianshang' : 'jiantouxianxia'} type='label2' nopaddingMode={false} color={textStyle.textColor}></Icon>


                {visible && <Image className="base" source={{
        uri: 'https://p0.meituan.net/travelcube/e05b66b54a6d1ebdc748f6cf13934fa4562.png'
    }} style={{
        zIndex: zIndex
    }}/>}

            </View>
            {visible && <View className='city-deop-down-modal' style={{
        zIndex: zIndex
    }}>
                    {isTop && <View className='city-deop-down-modal-card-checked'>
                                <Text className='city-deop-down-modal-card-text-checked'>{checkedCity === null || checkedCity === void 0 ? void 0 : checkedCity.title}</Text>
                            </View>}
                    {citydata === null || citydata === void 0 ? void 0 : citydata.map((it, index) => <View className={it.value === checkedCity.value ? 'city-deop-down-modal-card-checked' : 'city-deop-down-modal-card'} style={it.value === checkedCity.value ? style : {}} onClick={() => {
        onClick(it, index);
    }}>
                                <Text className={it.value === checkedCity.value ? 'city-deop-down-modal-card-text-checked' : 'city-deop-down-modal-card-text'}>{it === null || it === void 0 ? void 0 : it.title}</Text>
                            </View>)}
                </View>}
        </View>;
};
export default memo(MyComponent);
